class TobCaseSpaceJourney {
  constructor(section) {
    this.section = section;

    if (this.section.dataset.initialized === 'true') return;
    this.section.dataset.initialized = 'true';

    this.grid = section.querySelector('.js-space-journey-grid');
    this.dataNode = section.querySelector('.js-space-journey-data');
    this.lightbox = section.querySelector('.js-space-journey-lightbox');
    this.lightboxImage = section.querySelector('.js-space-journey-lightbox-image');
    this.lightboxCaption = section.querySelector('.js-space-journey-lightbox-caption');
    this.prevButton = section.querySelector('.js-space-journey-prev');
    this.nextButton = section.querySelector('.js-space-journey-next');
    this.closeOverlay = section.querySelector('.js-space-journey-close');
    this.openTriggers = section.querySelectorAll('.js-space-journey-open');

    this.items = this.getItems();
    this.currentIndex = 0;

    if (!this.grid || !this.items.length || !this.lightbox) return;

    this.boundKeydown = this.handleKeydown.bind(this);

    this.bindEvents();
  }

  getItems() {
    if (!this.dataNode) return [];
    try {
      const parsed = JSON.parse(this.dataNode.textContent);
      return parsed.filter((item) => item.image || item.image_large);
    } catch (error) {
      console.error('Space journey JSON parse error:', error);
      return [];
    }
  }

  bindEvents() {
    this.openTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.open(Number(trigger.dataset.index));
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.open(Number(trigger.dataset.index));
        }
      });
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.prev();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.next();
      });
    }

    if (this.closeOverlay) {
      this.closeOverlay.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', this.boundKeydown);

    this.lightbox.addEventListener('click', (event) => {
      const content = event.target.closest('.tob-case-space-journey-lightbox__content');
      const nav = event.target.closest('.tob-case-space-journey-lightbox__nav');

      if (!content && !nav) {
        this.close();
      }
    });
  }

  handleKeydown(event) {
    const isOpen = this.lightbox && !this.lightbox.hasAttribute('hidden');
    if (!isOpen) return;

    if (event.key === 'Escape') this.close();
    if (event.key === 'ArrowLeft') this.prev();
    if (event.key === 'ArrowRight') this.next();
  }

  render() {
    const item = this.items[this.currentIndex];
    if (!item || !this.lightboxImage) return;

    const src = item.image_large || item.image;
    this.lightboxImage.src = src;
    this.lightboxImage.alt = item.alt || '';

    if (this.lightboxCaption) {
      this.lightboxCaption.textContent = item.title || '';
    }
  }

  open(index) {
    this.currentIndex = index;
    this.render();
    this.lightbox.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.lightbox.setAttribute('hidden', 'hidden');
    document.body.classList.remove('overflow-hidden');
  }

  prev() {
    this.currentIndex = this.currentIndex - 1 < 0 ? this.items.length - 1 : this.currentIndex - 1;
    this.render();
  }

  next() {
    this.currentIndex = this.currentIndex + 1 >= this.items.length ? 0 : this.currentIndex + 1;
    this.render();
  }
}

function initTobCaseSpaceJourney(scope = document) {
  const sections = scope.querySelectorAll('.tob-case-space-journey');
  sections.forEach((section) => new TobCaseSpaceJourney(section));
}

document.addEventListener('DOMContentLoaded', () => {
  initTobCaseSpaceJourney(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initTobCaseSpaceJourney(event.target);
});